module.exports = __webpack_public_path__ + "a7f38d59743d7d847519e3f28f27c039.svg";